import {
  CREATE_MASTERCLASS_CERTIFICATE,
  CREATE_MASTERCLASS_CERTIFICATE_FAILED,
  CREATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
  DELETE_MASTERCLASS_CERTIFICATE,
  DELETE_MASTERCLASS_CERTIFICATE_FAILED,
  DELETE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
  GET_MASTERCLASS_CERTIFICATE,
  GET_MASTERCLASS_CERTIFICATE_FAILED,
  GET_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
  UPDATE_MASTERCLASS_CERTIFICATE,
  UPDATE_MASTERCLASS_CERTIFICATE_FAILED,
  UPDATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
} from '../../types/masterclass/masterclassCertificateTypes';

// get_masterclass_certificate
export const getMasterclassCertificates = () => {
  return {
    type: GET_MASTERCLASS_CERTIFICATE,
  };
};
export const getMasterclassCertificatesSuccessful = (payload) => {
  return {
    type: GET_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
    payload,
  };
};
export const getMasterclassCertificatesFailed = (payload) => {
  return {
    type: GET_MASTERCLASS_CERTIFICATE_FAILED,
    payload,
  };
};

// create_masterclass_certificate
export const createMasterclassCertificate = (payload) => {
  return {
    type: CREATE_MASTERCLASS_CERTIFICATE,
    payload,
  };
};
export const createMasterclassCertificateSuccessful = (payload) => {
  return {
    type: CREATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
    payload,
  };
};
export const createMasterclassCertificateFailed = (payload) => {
  return {
    type: CREATE_MASTERCLASS_CERTIFICATE_FAILED,
    payload,
  };
};

// update_masterclass_certificate
export const updateMasterclassCertificate = (payload) => {
  return {
    type: UPDATE_MASTERCLASS_CERTIFICATE,
    payload,
  };
};
export const updateMasterclassCertificateSuccessful = (payload) => {
  return {
    type: UPDATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
    payload,
  };
};
export const updateMasterclassCertificateFailed = (payload) => {
  return {
    type: UPDATE_MASTERCLASS_CERTIFICATE_FAILED,
    payload,
  };
};

// delete_masterclass_certificate
export const deleteMasterclassCertificate = (payload) => {
  return {
    type: DELETE_MASTERCLASS_CERTIFICATE,
    payload,
  };
};
export const deleteMasterclassCertificateSuccessful = (payload) => {
  return {
    type: DELETE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
    payload,
  };
};
export const deleteMasterclassCertificateFailed = (payload) => {
  return {
    type: DELETE_MASTERCLASS_CERTIFICATE_FAILED,
    payload,
  };
};
